//@flow

export async function extractFileData(
  url: string
): Promise<{
  error: boolean,
  type: string,
  size: number,
}> {
  try {
    const response = await fetch(url);

    const contentLength = Number(response.headers.get('content-length')) || 0;
    const contentType = response.headers.get('content-type') || '';

    return {
      type: contentType,
      size: contentLength,
      error: false,
    };
  } catch (error) {
    console.error(error);

    return {
      error: true,
      type: '',
      size: 0,
    };
  }
}

const SPREADSHEET_MIME_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.google-apps.spreadsheet',
  'application/vnd.google-apps.document',
  'application/vnd.google-apps.presentation',
];

const WORD_MIMETYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

const PDF_MIMETYPES = ['application/pdf'];

export function getLabelFromMimetype(mimetype: string): string {
  if (mimetype.includes('image')) {
    return 'Imagen';
  }

  if (mimetype.includes('video')) {
    return 'Video';
  }

  if (SPREADSHEET_MIME_TYPES.includes(mimetype)) {
    return 'Hoja de cálculo';
  }

  if (WORD_MIMETYPES.includes(mimetype)) {
    return 'Word';
  }

  if (PDF_MIMETYPES.includes(mimetype)) {
    return 'PDF';
  }

  return 'Archivo';
}
